import { ROUTE_WELCOME } from '@/constants/routes';
import { clearAllCookies } from '@/utilities/cookies';
import { useMount } from '@simplywallst/ui-core';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { redirect } from 'redux-first-router';
import { logoutUser } from '@simplywallst/services';
import { withAuth } from '@/utilities/queries';

function useLogout() {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const logout = useCallback(async () => {
    await Promise.all([withAuth(logoutUser), clearAllCookies()]);
    queryClient.clear();
    dispatch(redirect({ type: ROUTE_WELCOME }));
    try {
      const { analytics } = window;
      analytics.logout();
    } catch {
      console.warn('Unable to logout');
    }
  }, []);
  return { logout };
}
export function Logout() {
  const { logout } = useLogout();

  useMount(() => {
    logout();
  });
  return null;
}
